import { all, getContext, put, takeLatest } from 'redux-saga/effects';
import { Logger } from 'utils/Logger';
import CasesSummary from 'models/CasesSummary';
import { requestCasesSummaryFailure, requestCasesSummarySuccess } from './actions';
import { casesSummary } from './types';

const logger = new Logger('Saga:Dashboard');

export function* getCasesSummary(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield authApiService.get(routerService.generate('api.platform.cases_summary'));
    const data = CasesSummary.deserialize(response.data);

    logger.info('Got new cases summary');
    if (action.promise) action.promise.resolve(data);
    yield put(requestCasesSummarySuccess(data));
  } catch (error) {
    logger.error(error);
    if (action.promise) action.promise.reject(error);
    yield put(requestCasesSummaryFailure(error));
  }
}

export default function* casesSummarySaga() {
  return yield all([takeLatest(casesSummary.request, getCasesSummary)]);
}
